/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Screen name constants for ScreenController registration and Redux tracking.
 * Each value must be unique and match the name passed to setActiveScreen.
 */
export const ScreenControllerTypes = {
  SPLASH_SCREEN: "SPLASH_SCREEN",
  SIGN_IN_SCREEN: "SIGN_IN_SCREEN",
  FULL_SCREEN_PLAYBACK: "FULL_SCREEN_PLAYBACK",
  HOME_SCREEN: "HOME_SCREEN",
  GUIDE_SCREEN: "GUIDE_SCREEN",
  SELECT_PROFILE_SCREEN: "SELECT_PROFILE_SCREEN",
  MANAGE_PROFILES_SCREEN: "MANAGE_PROFILES_SCREEN",
  PROFILE_DETAILS_SCREEN: "PROFILE_DETAILS_SCREEN",
  CONTENT_DETAIL_SCREEN: "CONTENT_DETAIL_SCREEN",
  MY_HUB_SCREEN: "MY_HUB_SCREEN",
  MANAGE_SERIES_RECORDINGS_SCREEN: "MANAGE_SERIES_RECORDINGS_SCREEN",
  SPORTS_HUB_SCREEN: "SPORTS_HUB_SCREEN",
  SHOWS_AND_MOVIES_SCREEN: "SHOWS_AND_MOVIES_SCREEN",
  SEARCH_SCREEN: "SEARCH_SCREEN",
  SEE_MORE_SCREEN: "SEE_MORE_SCREEN",
  SETTINGS_SCREEN: "SETTINGS_SCREEN",
  PLAYER_CAROUSEL: "PLAYER_CAROUSEL"
} as const;
